import { Routes } from '@angular/router';
import { AuthGuard } from '@pcscol-portail/ng-auth';


export const routes: Routes = [
    {
        path: 'auth', loadChildren: () => import('./shared/auth/auth-wrapper.module').then((m) => m.AuthWrapperModule),
    },
    { path: 'accueil', redirectTo: '/', pathMatch: 'full' },
    { path: '', loadComponent: () => import('./pages/page/page.component').then(c => c.PageComponent), canActivate: [AuthGuard] },
    {
        path: 'donnees-personnelles',
        loadComponent: () => import('./components/donnees-personnelles/donnees-personnelles.component').then(m => m.DonneesPersonnellesComponent),
        canActivate: [AuthGuard],
    },
];
